import React from 'react';
import jump from 'jump.js';

import ArrowButton from './ArrowButton';

import style from './ScrollIndicator.module.scss';

// Smooth scroll to content start
const scrollClick = (scrollClass, scrollOffset) => {
  jump(scrollClass, {
    offset: scrollOffset,
  });
};

const ScrollIndicator = props => {
  return (
    <div
      className={style.scrollIndicator}
      onClick={() => {
        scrollClick(props.scrollClass, props.scrollOffset);
      }}
    >
      <ArrowButton />
      <div className={style.scrollText}>Scroll</div>
    </div>
  );
};

export default ScrollIndicator;



// WEBPACK FOOTER //
// ./src/components/ui/ScrollIndicator.js